<navigation [navigationDetails]="navigationDetails">
    <transaction-header [defaultTitleKey]="title" [accessLevel]="accessLevel"></transaction-header>
    <div class="standard-form">
        <notification [notificationDetails]="error">
        </notification>
    </div>
    <div class="fm-buttons"></div>
</navigation>
